// extracted by mini-css-extract-plugin
module.exports = {"link_wrapper":"dece2e673c--link_wrapper--XGi39","link":"dece2e673c--link--xYQdD","icon":"dece2e673c--icon--DtnJk"};